import React from 'react';

import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { useSelector } from 'react-redux';

import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';
import Global from '../../../../../store/global-selectors';
import { useSalesOrderIdContext } from '../../../../context/sales-order-id-context-provider';

import style from './shipment-details.module.less';

const ReturnCounter = ({ counter }) => {
  const salesOrderId = useSalesOrderIdContext();
  const totalReturnCount = useSelector((state) => {
    const salesOrder = Global.selectEntitiesSalesOrderById(state, { salesOrderId }) || {};

    return salesOrder?.returnIds?.length || 0;
  });

  if (totalReturnCount <= 1) {
    return null;
  }

  return (
    <Text
      className={style['return-counter']}
      formattedMessageValues={{
        count: <FormattedNumber value={counter} />,
        total: <FormattedNumber value={totalReturnCount} />,
      }}
      textType={TextType.Caption}
      value={messages.returnCounter}
    />
  );
};

export default ReturnCounter;

ReturnCounter.propTypes = {
  counter: PropTypes.number.isRequired,
};
